(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-native-editor"]) return;
  try {
    
class TapisTechEditor extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    if (!customElements.get("tt-preview-modal")) { customElements.whenDefined("tt-preview-modal").then(()=>{if(this.isConnected)this.connectedCallback();}); return; }
    this.controller = new AbortController();
    this.signal = this.controller.signal;
    this.config = JSON.parse(this.querySelector('[data-config]').textContent);
    this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
    this.canvas = this.querySelector('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.select = this.querySelector('[data-format]');
    this.zoomInput = this.querySelector('[data-zoom]');
    this.confirm = this.querySelector('[data-confirm]');
    this.submit = this.querySelector('[data-add]');
    this.fileInput = this.querySelector('[data-file]');
    this.status = this.querySelector('[data-status]');
    this.mockupButton = this.querySelector('[data-mockup-button]');
    this.mockupStatus = this.querySelector('[data-mockup-status]');
    this.mockupGallery = this.querySelector('[data-mockup-gallery]');
    this.previewModal = this.querySelector('tt-preview-modal');
    this.mockupDialog = this.querySelector('[data-mockup-dialog]');
    this.mockupAccept = this.querySelector('[data-mockup-accept]');
    this.previewVersion = 0;
    this.formats = this.config.formats;
    const selected = new URL(location.href).searchParams.get('variant');
    if (this.formats.some(f => String(f.id) === selected)) this.select.value = selected;
    this.image = null;
    this.sequence = 0;
    this.busy = false;
    this.ready = false;
    this.changeFormat();
    this.on(this.fileInput, 'change', () => this.load(this.fileInput.files[0]));
    this.on(this.select, 'change', () => this.changeFormat());
    this.on(this.zoomInput, 'input', () => { this.zoom = Number(this.zoomInput.value); this.changed(); });
    this.on(this.querySelector('[data-fit]'), 'click', () => { this.mode = this.mode === 'cover' ? 'contain' : 'cover'; this.resetPosition(); });
    this.on(this.querySelector('[data-rotate]'), 'click', () => { this.rotation = (this.rotation + 90) % 360; this.resetPosition(); });
    this.on(this.querySelector('[data-reset]'), 'click', () => { this.mode = 'cover'; this.rotation = 0; this.resetPosition(); });
    this.on(this.confirm, 'change', () => this.refresh());
    this.on(this.mockupButton, 'click', () => this.generateMockup());
    this.on(this.mockupAccept, 'click', () => {
      if (!this.mockupReady || this.previewBusy) return;
      this.mockupViewed = true;
      this.mockupDialog.close();
      this.refresh();
      this.status.textContent = '';
      this.confirm.focus();
    });
    this.on(this.querySelector('[data-form]'), 'submit', event => { event.preventDefault(); this.addToCart(); });
    this.on(this.canvas, 'pointerdown', event => {
      if (!this.image || this.busy || !event.isPrimary) return;
      this.canvas.setPointerCapture(event.pointerId);
      this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, startX: this.x, startY: this.y };
      this.canvas.focus({ preventScroll: true });
    });
    this.on(this.canvas, 'pointermove', event => {
      if (!this.drag || event.pointerId !== this.drag.id) return;
      const rect = this.canvas.getBoundingClientRect();
      this.x = this.drag.startX + (event.clientX - this.drag.x) / rect.width;
      this.y = this.drag.startY + (event.clientY - this.drag.y) / rect.height;
      this.changed();
    });
    for (const name of ['pointerup', 'pointercancel', 'lostpointercapture']) this.on(this.canvas, name, () => { this.drag = null; });
    this.on(this.canvas, 'keydown', event => {
      const moves = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
      if (!moves[event.key] || !this.image || this.busy) return;
      event.preventDefault();
      const step = event.shiftKey ? 0.04 : 0.005;
      this.x += moves[event.key][0] * step;
      this.y += moves[event.key][1] * step;
      this.changed();
    });
    const drop = this.querySelector('[data-drop]');
    this.on(drop, 'dragover', event => { event.preventDefault(); drop.classList.add('is-dragging'); });
    this.on(drop, 'dragleave', () => drop.classList.remove('is-dragging'));
    this.on(drop, 'drop', event => {
      event.preventDefault(); drop.classList.remove('is-dragging');
      if (!this.busy) this.load(event.dataTransfer.files[0]);
    });
    this.on(window, 'pageshow', () => { if (!this.busy) this.refresh(); });
    this.loadCatalog();
  }

  disconnectedCallback() {
    if (this.mockupDialog?.open) this.mockupDialog.close();
    this.controller?.abort();
    this.controller = null;
    this.sequence++;
    this.previewController?.abort();
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
  }

  on(target, event, handler) { target.addEventListener(event, handler, { signal: this.signal }); }
  text(key) { return this.copy[key] || key; }
  message(key, isError = false) { this.status.textContent = this.text(key); this.status.dataset.error = String(isError); }

  async loadCatalog() {
    this.ready = Boolean(this.config.enabled && this.formats.every(f => Number.isInteger(f.printWidth) && Number.isInteger(f.printHeight) && f.printWidth > 0 && f.printHeight > 0 && f.printWidth * f.printHeight <= 45000000));
    this.message(this.ready ? 'start' : 'preview_only');
    this.refresh();
  }

  changeFormat() {
    this.format = this.formats.find(f => String(f.id) === this.select.value) || this.formats[0];
    if (!this.format) return;
    this.mode = 'cover'; this.rotation = 0;
    this.querySelector('[data-price]').textContent = this.format.price;
    this.querySelector('[data-dimensions]').textContent = this.format.label;
    this.querySelector('[data-material]').textContent = this.text(this.format.material);
    this.canvas.width = 1200;
    this.canvas.height = Math.round(1200 * ((this.format.printHeight / this.format.printWidth) || this.format.height / this.format.width));
    this.canvas.style.aspectRatio = `${this.canvas.width} / ${this.canvas.height}`;
    this.resetPosition();
  }

  resetPosition() {
    this.x = 0; this.y = 0; this.zoom = 1; this.zoomInput.value = '1';
    this.changed();
  }

  changed() {
    this.previewVersion++;
    this.previewController?.abort();
    this.previewBusy = false;
    this.mockupReady = false;
    this.mockupViewed = false;
    if (this.mockupDialog?.open) this.mockupDialog.close();
    this.mockupRequest = null;
    this.previewModal.reset();
    if (this.mockupStatus) this.mockupStatus.textContent = this.text('mockup_hint');
    this.confirm.checked = false;
    this.savedDesign = null;
    this.querySelector('[data-fit]').textContent = this.text(this.mode === 'cover' ? 'contain' : 'cover');
    this.querySelector('[data-zoom-value]').textContent = `${Math.round(this.zoom * 100)} %`;
    this.render();
    this.refresh();
    if (this.image) this.message('adjust');
  }

  async load(file) {
    if (!file || this.busy) return;
    if (!['image/png', 'image/jpeg'].includes(file.type) || file.size === 0 || file.size > 20 * 1024 * 1024) { this.message('file_error', true); return; }
    const sequence = ++this.sequence;
    this.fileInput.value = '';
    this.loading = true;
    this.refresh();
    this.message('loading');
    const url = URL.createObjectURL(file);
    try {
      const image = new Image(); image.src = url;
      await image.decode();
      if (sequence !== this.sequence || !this.isConnected) { URL.revokeObjectURL(url); return; }
      if (image.naturalWidth * image.naturalHeight > 50000000 || Math.min(image.naturalWidth, image.naturalHeight) < 100) throw new Error('Dimensions');
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = url;
      this.image = image;
      this.fileName = file.name;
      this.querySelector('[data-file-name]').textContent = file.name;
      this.mode = 'cover'; this.rotation = 0; this.resetPosition();
      this.message('adjust');
    } catch (error) {
      URL.revokeObjectURL(url);
      if (sequence === this.sequence) this.message('file_error', true);
    } finally {
      if (sequence === this.sequence) { this.loading = false; this.refresh(); }
    }
  }

  geometry(width, height) {
    const image = this.image;
    const turned = this.rotation % 180 !== 0;
    const iw = turned ? image.naturalHeight : image.naturalWidth;
    const ih = turned ? image.naturalWidth : image.naturalHeight;
    const scale = (this.mode === 'contain' ? Math.min(width / iw, height / ih) : Math.max(width / iw, height / ih)) * this.zoom;
    const limitX = Math.abs(iw * scale - width) / 2;
    const limitY = Math.abs(ih * scale - height) / 2;
    const x = Math.max(-limitX, Math.min(limitX, this.x * width));
    const y = Math.max(-limitY, Math.min(limitY, this.y * height));
    return { scale, x, y, iw, ih };
  }

  paint(context, width, height) {
    context.clearRect(0, 0, width, height);
    context.fillStyle = '#ffffff'; context.fillRect(0, 0, width, height);
    if (!this.image) return;
    const g = this.geometry(width, height);
    context.imageSmoothingEnabled = true; context.imageSmoothingQuality = 'high';
    context.save(); context.translate(width / 2 + g.x, height / 2 + g.y);
    context.rotate(this.rotation * Math.PI / 180);
    context.drawImage(this.image, -this.image.naturalWidth * g.scale / 2, -this.image.naturalHeight * g.scale / 2, this.image.naturalWidth * g.scale, this.image.naturalHeight * g.scale);
    context.restore();
  }

  render() {
    if (!this.format) return;
    if (this.image) {
      const g = this.geometry(this.canvas.width, this.canvas.height);
      this.x = g.x / this.canvas.width; this.y = g.y / this.canvas.height;
      const physicalScale = (this.mode === 'contain' ? Math.min(this.format.width / 2.54 / g.iw, this.format.height / 2.54 / g.ih) : Math.max(this.format.width / 2.54 / g.iw, this.format.height / 2.54 / g.ih)) * this.zoom;
      this.dpi = Math.floor(1 / physicalScale);
    } else this.dpi = 0;
    this.paint(this.ctx, this.canvas.width, this.canvas.height);
    this.querySelector('[data-empty]').hidden = Boolean(this.image);
    const quality = this.querySelector('[data-quality]');
    quality.textContent = this.image ? `${this.text(this.dpi >= 150 ? 'quality_good' : this.dpi >= 100 ? 'quality_soft' : 'quality_low')} · ${this.dpi} dpi` : this.text('quality_waiting');
    quality.dataset.quality = !this.image ? 'waiting' : this.dpi >= 150 ? 'good' : this.dpi >= 100 ? 'warning' : 'error';
  }

  refresh() {
    const lock = this.busy || this.loading || this.previewBusy;
    this.select.disabled = Boolean(lock);
    this.fileInput.disabled = Boolean(lock);
    for (const control of this.querySelectorAll('[data-edit]')) control.disabled = Boolean(lock || !this.image);
    this.confirm.disabled = Boolean(lock || !this.image || !this.mockupViewed);
    this.submit.disabled = Boolean(lock || !this.image || this.dpi < 100 || !this.mockupViewed || !this.mockupReady || !this.confirm.checked || !this.ready || !this.format?.available);
    this.mockupAccept.disabled = Boolean(this.previewBusy || !this.mockupReady);
    this.querySelector('[data-mockup-required]').textContent = this.text(this.mockupViewed ? 'mockup_accepted' : 'mockup_required');
    this.submit.textContent = this.text(this.busy ? 'saving' : 'add');
    this.mockupButton.disabled = Boolean(lock || !this.image || this.dpi < 100 || !this.format?.available);
    this.mockupButton.textContent = this.text(this.previewBusy ? 'mockup_loading' : this.mockupReady ? 'mockup_ready_button' : 'mockup_button');
    this.previewModal.loading(Boolean(this.previewBusy));
    this.setAttribute('aria-busy', String(Boolean(lock)));
  }

  async exportArtwork() {
    const canvas = document.createElement('canvas');
    canvas.width = this.format.printWidth; canvas.height = this.format.printHeight;
    if (!canvas.width || !canvas.height) throw new Error('No verified print area');
    this.paint(canvas.getContext('2d'), canvas.width, canvas.height);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    canvas.width = 1; canvas.height = 1;
    if (!blob || blob.size > 20 * 1024 * 1024) throw new Error('Artwork too large');
    return blob;
  }

  async previewImage() {
    const canvas = document.createElement('canvas');
    canvas.width = Math.min(2048,this.format.printWidth);
    canvas.height = Math.round(canvas.width*this.format.printHeight/this.format.printWidth);
    this.paint(canvas.getContext('2d'),canvas.width,canvas.height);
    const blob = await new Promise(resolve=>canvas.toBlob(resolve,'image/jpeg',.92));
    canvas.width=1; canvas.height=1;
    if (!blob || blob.size>4*1024*1024) throw new Error('Preview too large');
    return blob;
  }

  async generateMockup() {
    if (this.mockupButton.disabled) return;
    this.openMockup();
    if (this.mockupReady) return;
    const version=this.previewVersion;
    this.previewController?.abort();
    const controller=new AbortController();
    this.previewController=controller;
    const signal=controller.signal;
    const timeout=setTimeout(()=>controller.abort(),180000);
    this.previewBusy=true;
    this.mockupStatus.textContent=this.text('mockup_loading');
    this.refresh();
    try {
      if (!this.mockupRequest) this.mockupRequest={id:crypto.randomUUID(),blob:await this.previewImage()};
      const requestId=this.mockupRequest.id;
      const response=await fetch(this.config.previewUrl,{method:'POST',signal,headers:{'Content-Type':'image/jpeg','X-Variant-Id':String(this.format.id),'X-Preview-Id':requestId},body:this.mockupRequest.blob});
      if (!response.ok) throw new Error(response.status===429?'rate_limit':'preview_failed');
      for (let attempt=0;attempt<35;attempt++) {
        await new Promise((resolve,reject)=>{
          const abort=()=>{clearTimeout(timer);reject(new DOMException('Aborted','AbortError'));};
          const timer=setTimeout(()=>{signal.removeEventListener('abort',abort);resolve();},4500);
          if(signal.aborted) abort(); else signal.addEventListener('abort',abort,{once:true});
        });
        const polled=await fetch(`${this.config.previewUrl}/${requestId}`,{signal});
        if(!polled.ok) throw new Error('preview_failed');
        const result=await polled.json();
        if(version!==this.previewVersion || !this.isConnected) return;
        if(result.status!=='completed') continue;
        if(!Array.isArray(result.mockups) || !result.mockups.length) throw new Error('preview_failed');
        await this.previewModal.setImages(result.mockups.map(mockup=>mockup.src),signal);
        if(version!==this.previewVersion || !this.isConnected) return;
        this.mockupReady=true;
        this.mockupGallery.hidden=false;
        this.mockupStatus.textContent=this.text('mockup_ready');
        return;
      }
      throw new Error('preview_failed');
    } catch(error) {
      if(version===this.previewVersion && this.isConnected) {
        this.mockupStatus.textContent=this.text(error.message==='rate_limit'?'mockup_rate':error.name==='AbortError'?'mockup_timeout':'mockup_error');
        if(error.name!=='AbortError') this.mockupRequest=null;
      }
    } finally {
      clearTimeout(timeout);
      if(version===this.previewVersion) {this.previewBusy=false;this.refresh();}
    }
  }

  openMockup() {
    this.previewModal.open(this.mockupButton);
  }

  async addToCart() {
    if (this.submit.disabled || this.busy || !this.mockupViewed || !this.mockupReady) return;
    this.busy = true; this.refresh(); this.message('saving');
    try {
      if (!this.savedDesign) {
        const blob = await this.exportArtwork();
        this.savedDesign = { id: crypto.randomUUID(), blob };
      }
      const existingResponse = await fetch(this.config.cartJson, { signal: this.signal, credentials: 'same-origin' });
      if (!existingResponse.ok) throw new Error('Cart unavailable');
      const cart = await existingResponse.json();
      if (cart.items.some(item => item.properties?._tt_design === this.savedDesign.id)) { location.assign(this.config.cartUrl); return; }
      const form = new FormData();
      form.set('id', String(this.format.id));
      form.set('quantity', '1');
      form.set('properties[_tt_design]', this.savedDesign.id);
      form.set('properties[_tt_artwork]', this.savedDesign.blob, `tapis-tech-${this.savedDesign.id}.png`);
      form.set('properties[_tt_source_dpi]', String(this.dpi));
      this.previewModal.images.forEach((src,index)=>form.set(`properties[_tt_preview_${index+1}]`,src));
      form.set('properties[_tt_preview]',this.previewModal.images[this.previewModal.selected] || this.previewModal.images[0]);
      form.set('properties[Personnalisation]', this.text('saved'));
      const response = await fetch(this.config.cartAdd, {
        method: 'POST', credentials: 'same-origin', signal: this.signal,
        headers: { 'Accept': 'application/json' }, body: form
      });
      if (!response.ok) throw new Error('Cart failed');
      location.assign(this.config.cartUrl);
    } catch (error) {
      if (error.name !== 'AbortError') this.message('save_error', true);
      this.busy = false; this.refresh();
    }
  }
}
if (!customElements.get('tt-native-editor')) customElements.define('tt-native-editor', TapisTechEditor);


  } catch(e) { console.error(e); }
})();
})();
